import BtnToggle from 'components/generic/BtnToggle'
import Heading from 'components/generic/Heading'
import MainContainer from 'components/generic/MainContainer'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { COOKIES, OVER_18, UNDER_18 } from './policies'
import Policy from './Policy'
import styles from './privacyPolicy.module.scss'

export enum Policies {
  UNDER_18 = 'under18',
  OVER_18 = 'over18',
  COOKIE_POLICY = 'cookiePolicy',
}

interface PrivacyPolicyOption {
  name: string
  key: Policies
}

const PrivacyPolicy = () => {
  const { t }: { t: any } = useTranslation('strPolicies')
  const options: PrivacyPolicyOption[] = [
    {
      name: t('over18'),
      key: Policies.OVER_18,
    },
    {
      name: t('under18'),
      key: Policies.UNDER_18,
    },
    {
      name: t('cookiePolicy'),
      key: Policies.COOKIE_POLICY,
    },
  ]

  const [selectedOpt, setSelectedOpt] = useState<Policies>(options[0].key)

  return (
    <MainContainer>
      <div className={styles.privacyPolicy}>
        <Heading>{t('heading')}</Heading>
        <div>
          {' '}
          <p>{t('intro')}:</p>
          <div className={styles.options}>
            {options.map(({ name, key }, i) => (
              <BtnToggle
                isActive={selectedOpt === key}
                key={key}
                onClick={() => {
                  setSelectedOpt(key)
                }}
                className={styles.tab}
              >
                {name}
              </BtnToggle>
            ))}
          </div>
        </div>
        {selectedOpt === 'under18' && <Policy {...UNDER_18} setSelectedTab={setSelectedOpt} />}
        {selectedOpt === 'over18' && <Policy {...OVER_18} setSelectedTab={setSelectedOpt} />}
        {selectedOpt === 'cookiePolicy' && <Policy {...COOKIES} setSelectedTab={setSelectedOpt} />}
      </div>
    </MainContainer>
  )
}

export default PrivacyPolicy
